export enum Preferences {
    USERPREFERENCES = 'userPreferences',
    DEBUG = 'debug',
    STATISTICIAN = 'statistician',
    /*THEME = 'theme',*/
    USERCONTROLPANEL = 'userControlPanel',
    LANGUAGES = 'languages',
    TYPEIMPORT = 'importTypes',
    CONNECTORS = 'connectors',
    CENTREPREFERENCES = 'centrePreferences',
    ASKCONSENT = 'askConsent',
    GCPSTRATEGY = 'gcpStrategies',
    CUSTOMEXPORTS = 'customExports'
}
